import { render, staticRenderFns } from "./number-row.vue?vue&type=template&id=61768424&"
import script from "./number-row.vue?vue&type=script&lang=js&"
export * from "./number-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports